import React from "react";
import { Routes, Route } from "react-router-dom";
import { BaseRoute } from "../routing/PrivateRoute";
import { OrganisationsScreen } from "./screens/Organisations";
import { ViewOrganisation } from "./screens/ViewOrganisation";
import { CollectionsScreen } from "./screens/Collections";

export const StatsProvider = (): JSX.Element => {
    return (
        <Routes>
            <Route
                path="/organisations/view/:id"
                element={<BaseRoute permission="StatsViewAll" component={ViewOrganisation} />}
            />
            <Route
                path="/organisations/*"
                element={<BaseRoute permission={"StatsViewAll"} component={OrganisationsScreen} />}
            />
            <Route
                path="/storycollections/*"
                element={<BaseRoute permission={"StatsViewAll"} component={CollectionsScreen} />}
            />
        </Routes>
    );
};
